import en from 'vuetify/lib/locale/en';

export default {
    ...en,

    app: {
        dashboard: "Dashboard",
        alarms: "Alarms",
        screenshots: "Screenshots",
        users: "Users",
        account: "Account",
        organizations: "Organizations",
        support: "Support",
        logout: "Logout",
    },

    signIn: {
        required: "Required field",
        verificationCode: "Verification code",
        validate: "Validate",
        cancel: "Cancel",
        email: "Email",
        username: "Username",
        phonenumbermustbevalid: "Phone number must be valid",
        newpassword: "New password",
        passwordconfirmation: "Confirm Password",
        nameisrequired: "Name is required",
        passwordisrequired: "New password is required",
        yourpasswordshouldcontainatleastoneuppercase: "Your password should contain at least one upper case",
        yourpasswordshouldcontainatleastonedigit: "your password should contain at least one digit",
        yourpasswordshouldcontainatleastonelowercase: "Your password should contain at least one lower case",
        yourpasswordmustcontainatleastonespecialcharacter: "Your password must contain at least one special character",
        yourpasswordshouldcontainatleast8characters: "Your password should contain at least 8 characters",
        confirmationisrequired: "Confirmation is required",
        country: "Country",
        phonenumber: "Phone number",
        confirmationPasswordNotTheSame: "Wrong confirmation password", 
        emailalreadyinuse: "Email address already in use",
        wrongverificationcode: "Wrong verification code",
        inscriptionValidate: "Inscription done, you will be redirected to the login page."
    },

    login: {
        loginError: "Email / Password is incorrect",
        noOrganization: "Your account is not associated with any organization. Please contact UTC-SYSTEM support for more information.",
        passwordResetSendOK: "Only if account exist, password reset link is send by e-mail",
        passwordUpdated: "Password updated",
    },

    dashboard: {
        oragnizationCannotBeUsedRentalPeriod1: "This organization : ",
        oragnizationCannotBeUsedRentalPeriod2: ", cannot be used as it has reached the end of the rental period. Please contact UTC-SYSTEM for assistance.",
        statusCard: {
            device: "Device",
            monitored: "Monitored",
            status: "Status",
            critical: "Critical",
            warning: "Warning",
            ok: "Ok",
            maintenance: "Maintenance",
            batteryreplacementneeded: "battery remplacement needed",
            returnforcalibrationneeded: "recalibration needed",
            no: "No",
            renting: "Renting",
            singleexpiration: "rental expires soon or has expired",
            multipleexpiration: "rentals expire soon or have expired",
        },

        alarmsRecapCard: {
            alarmssummary: "Alarm Recap",
            alarm: "alarm",
            compared: "compared",
            tolastmonth: "to last month",
            currentlyactive: "currently active",
            notconsulted: "not consulted",
            notificationsaresentto : "Notifications are sent to",
            person: "person",
            people: "people",
            manage: "manage",
            day: "day",
            ago: "ago",
            equal: "equal",
            intrusion: "intrusion"
        },

        intrusionsRecapCard: {
            intrusionssummary: "Intrusion Recap",
            intrusion: "intrusion",
            compared: "compared",
            tolastmonth: "to last month",
            currentlyactive: "currently active",
            notconsulted: "not consulted",
            notificationsaresentto : "Notifications are sent to",
            person: "person",
            people: "people",
            manage: "manage",
            equal: "equal",
        },

        statistics: {
            statistics: "Statistics",
            operatingtime: "Operating time",
            operating: "Operating",
            alarmperutc: "Alarm(s) per UTC",
            alarm:"Alarms",
            incident:"Incidents",
            incidentperutc:"Incident(s) per UTC",
            noDataOperationTime: "No UTC have been in operation yet",
            noDataAlarmsCount: "No UTC have been in alarm state yet",
            noIncidents: "No incidents occurred",
            noIntrusions:"No UTC have been in intrusion state yet",
            time: "Time (h)",
            network: "Network Disconnection",
            intrusionperutc: "Intrusion(s) per UTC",
            intrusion:"Intrusions"
        }
    },

    utc: {
        addDevice: "Add device",
        deleteDevice: "Delete device",
        status: "Status",
        critical: "Critical",
        warning: "Warning",
        ok: "Ok",
        rentalexpiration: "Rental expiration",
        notrecommendedthreshold: "not recommended threshold",
        resetfilter: "Reset filter",
        batteryremplacementneeded: "Battery remplacement needed",
        maskedition: "Mask edition",
        thermographfeatures: "Thermograph Features",
        signals: "Signals",
        sortby: "Sort by",
        filterby: "Filter by",
        serialnb: "Serial number - (Default)",
        denomination: "Denomination",
        distancecategory: "Distance category",
        rangetype: "Range Type",
        hardversion: "Hardware Version",
        newDeviceMax: "Unable to add a device. You have reached your maximum number of UTC allowed on this organization. Please contact UTC-SYSTEM for assistance.", 
        softversion: "Software Version",
        rental: "Rental",

        newDevice: {
            addDevice: "Add a new device",
            serialNb: "Serial Number",
            mac: "MAC address",
            orderNb: "Contract Number",
            validate: "Validate",
            cancel: "Cancel",
            newDeviceOK: "New device added", 
            newDeviceNOK: "Unable to add a device. This may be due to an incorrect SN, an SN already in use, an incorrect MAC, or an invalid contract (non-existent or lease expired).", 
           
        },

        delDevice: {
            delDevice: "Delete device",
            serialNb: "Serial Number",
            mac: "MAC address",
            orderNb: "Contract Number",
            validate: "Validate",
            cancel: "Cancel",
            deleteDeviceOK: "Device deleted",
            deleteDeviceNOK: "Incorrect information for deleting a device from this organization",
        },
        

        utcCard: {
            emissivity: "Emissivity",
            triggerthreshold: "Trigger threshold",
            settings:"Settings",
            deviceCannotBeUsedRentalPeriod: "This device cannot be used as it has reached the end of the rental period. Please contact UTC-SYSTEM for assistance.",
        },

        systemDataCard: {
            systemdata: "System data",
            serialnumber: "Serial number",
            category: "Distance Category",
            type: "Range type",
            hardversion: "Hard version",
            softversion: "Soft version",
        },

        batteryCard: {
            backupbattery: "Backup battery",
            nobattery: "No battery",
            last: "Last",
            next: "Next",
            utcpoweredbybatteries: "UTC powered by batteries",
        },

        fileCard: {
            filestorage: "File storage",
            hereitisthestoragespaceforonedocumentspecifictothisutctohelpyouspotoridentifyit: "Here it is the storage space for one document specific to this utc, to help you spot or identify it",
            dropyourfileorclickhere: "Drop your file or click here",
            uploadthisdocument: "Upload this document",
            delete: "Delete",
            download: "Download", 
        },

        controlsCard: {
            permanent: 'Permanent',
            night: 'Night (22h - 6h)',
            progScreen: "Programmable screenshots",
            maskedition: "Mask edition", 
            thermographoptions: "Thermograph Options", 
            signals: "Signals",
            emissivity: "Emissivity",
            alarmparameters: "Alarm parameters",
            thresholdInfo: "Exemples :",
            thresholdInfo1: "Early fire detection : 55°C",
            thresholdInfo2: "Electrical equipment : 75°C",
            advancedconfiguration: "Advanced configuration",
            threshold: "System Threshold",
            trigger: "Trigger value",
            every: "every",
            customization: "Customization",
            degree: "Degree",
            frequency: "Frequency",
            time: "Time",
            language: "Language",
            minute: "minute",
            hour: "hour",
            day: "day",
            week: "week",
            month: "month (30)",
            denomination: "ID",
            reset: "Reset",
            save: "Save",
            sound: "Sound",
            alarmindicator: "Visual",
            multiplier: "Multiplier",
            takeapictureremotely: "Take a picture remotely",
            activateavisualeffectremotelyonutcahelptofindandidentifyit: "Activate a visual effect remotely on UTC, a help to find and identify it",
            period: "Period",
            entryDelay: "Entry Delay",
            exitDelay: "Exit Delay",
            hysteresis: "Hysteresis",
            triggerthreshold: "Trigger threshold",
            notifications: "Notifications",
            intrusionDetection: "Intrusion detection",
            warningnotif: "Disabling this setting suspends all notifications except the alarm email.",
            emissivityisrequired: "Emissivity is required",
            theemissivityvaluemustbeapositiverealnumber:"The emissivity value must be a positive real number",
            hysteresisisrequired:"Hysteresis is required",
            thehysteresisvaluemustbeapositiverealnumber: "The hysteresis value must be a positive real number",
            entryDelayisrequired:"Entry Delay is required",
            theentryDelayvaluemustbeapositiverealnumber:"the entry Delay value must be a positive real number",
            exitDelayisrequired:"Exit Delay is required",
            theexitDelayvaluemustbeapositiverealnumber:"the exit Delay value must be a positive real number",
            thresholdisrequired:"Threshold is required",
            thethresholdvaluemustbeapositiverealnumber:"The threshold value must be a positive real number",
            thethresholdvaluemustbebetween:"The threshold value must be between ",
            and:" and ",
            thetriggervaluemustbeapositiverealnumber:"This value must be a positive real number",
            theDelayvaluemustbeaninteger:"This value must be an integer",
            thetriggervaluemustbebetween:"The trigger value must be between ",
            denominationisrequired:"Denomination is required",
            intrusionparameters:"intrusion parameters",
            intrusion: "Intrusion",
            mode:"Mode",
            theEntryDelayvalueIntmustbebetween1and60:"The entry delay value must be between 1 s and 60 s (1 mn)",
            theExitDelayvalueIntmustbebetween10and600:"The exit delay value must be between 10 s and 600 s (10 mn)",
            theEntryDelayvaluemustbebetween0and300:"The entry delay value must be between 0 s and 300 s (5 mn)",
            theExitDelayvaluemustbebetween0and604800:"The exit delay value must be between 0 s and 604800 s (1 week)",
            modeselectionlocked:"This feature is not yet available.",
            screenshotOrdersentOK: "Screenshot order sent",
            screenshotOrdersentERR: "An error occured while sending screenshot order",
            findmeOrdersentOK: "Localisation order sent",
            findmeOrdersentERR: "An error occured while sending localisation order",
            updateSettingsOrdersentOK: "New settings order sent",
            theHysteresisvaluemustbebetween0and20: "The hysteresis value must be between 0 and 20",
            maskDetail: {
                takeapictureremotely: "Take a picture remotely",
                screenshotOrdersentOK: "Screenshot order sent",
                mask: "Mask",
                restrictAlarm: "Restrict Alarm",
                actions: "Actions",
                cancel: "Cancel",
                sendtoutc: "Send to UTC",
                tenthofimage:"A mask can't exceed 10% of the image",
                youwillexceedthenumberofauthorizedareas:"You can't create more than 5 masks.",
                yourorderhasbeensenttoUTC:"your order has been sent to UTC",
                yourordercouldnotbesenttoUTC:"your order could not be sent to UTC",
                alertdelete:"Warning : Mask modification / removal might not be instantaneously visible on the image if it was taken with the mask you want to change.",
                pleaseconsider: "Please consider taking a new screenshot to update your view.",
                createmaskinfo: "Create a mask (rectangle) by clicking on the image once for the first corner, then a second time for the opposite corner.",
                maxsize: "Mask maximum size : 10% of the image."
            },

            advancedOptionsDetail: {
                takeapictureremotely: "Take a picture remotely",
                screenshotOrdersentOK: "Screenshot order sent",
                addaregionofinterest: "Add a region of interest",
                addapointofinterest: "Add a point of interest",
                regionmanagement: "Region management",
                pointmanagement: "Point management",
                deleteregion: "Delete region(s)",
                deletepoint: "Delete point(s)",
                alertmanagement: "Alert management",
                thresholdexceedancealert: "Threshold exceedance alert",
                threshold: "Threshold",
                deletethresholdexceedancealert: "Delete threshold exceedance alert",
                temperaturedifferencealert: "Temperature difference alert",
                difference: "Difference",
                deletetemperaturedifferencealert: "Delete temperature difference alert",
                cancel: "Cancel",
                sendtoutc: "Send to UTC",
                youwillexceedthenumberofauthorizedareas: "You can't create more than 5 regions",
                youwillexceedthenumberofauthorizedpoints: "You can't create more than 10 points",
                nothresholdexceedancealert: "No threshold exceedance alert",
                notemperaturedifferencealert: "No temperature difference alert",
                thethresholdvaluemustbeapositiveintegernumber: "The threshold value must be a positive integer number",
                thegapvaluemustbeapositiveintegernumber: "The gap value must be a positive integer number",
                youhavetochooseatleast2items: "You have to choose at least 2 items",
                atleastoneoftheregionstobedeleted:"At least one of the regions to be deleted is associated with an alert. To delete the region, please edit/delete the alert(s) concerned.",
                atleastoneofthepointstobedeleted: "At least one of the points to be deleted is associated with an alert. To delete the point, please edit/delete the alert(s) concerned.",
                yourorderhasbeensenttoUTC:"your order has been sent to UTC",
                yourordercouldnotbesenttoUTC:"your order could not be sent to UTC",
                avalueisrequired: "A value is required",
                anerrorexistsinalertsconfiguration: "An error exists in alerts configuration (regions or points). Please check that every input are filled correctly and try again.",
                createregioninfo: "Create a region (rectangle) by clicking on the image once for the first corner, then a second time for the opposite corner.",
                createpointinfo: "Create a point by clicking on the image at the desired location.",
                reminder: 'Reminder of best practices for temperature variations',
                gap0: 'Gap',
                gap1: 'X < 10°C',
                gap2: '10°C < X < 20°C',
                gap3: '20°C < X < 40°C',
                gap4: 'X > 40°C',
                time0: 'Action time',
                time1: '~ 6 months',
                time2: '~ 3 months',
                time3: '~ 1 month',
                time4: '~ 1 week',
            }
        },

        environmentalMetricsCard: {
            temperature: "Temperature",
            supply: "Supply",
            inside: "Inside",
            outside: "Outside",
            connected: "Connected",
            not: "Not",
            connection: "Connection",
            operatingtime: "Operating time",
            utcconnectionstatus: "UTC connection status",
            utcinternaltemperature: "UTC internal temperature",
            utcsupplymonitoring: "UTC supply monitoring",
            externaltemperatureonthefrontofutcscenedirection: "External temperature on the front of UTC (scene direction)",
            totaloperatingtimesincefirstuse: "Total operating time since first use"
        },
    },

    alarm: {
        search: "Search",
        filterby: "Filter by",
        alarmactive: "Alarm active",
        alarmnotconsulted: "Alarm not consulted",
        selectanalarmfolder: "Select an alarm folder",
        january: "January",
        february: "February",
        march: "March",
        april: "April",
        may: "May",
        june: "June",
        july: "July",
        august: "August",
        september: "September",
        october: "October",
        november: "November",
        december: "December",
        before: "Before",
        alarm: "alarm",

        alarmDetailsCard: {
            masksexcluded: "Masks excluded",
            masksincluded: "Masks included",
            notavailable: "Not available",
            time: "Time",
            thisalarmisactive: "This alarm is active",
            environment: "Environment",
            temperature: "Temperature",
            humidity: "Humidity",
            configuration: "Configuration",
            triggerthreshold: "Trigger threshold",
            emissivity: "Emissivity",
            internal: "Internal",
            fpatemperature: "FPA temperature",
            measuredtemperatures: "Measured temperatures",
            measurements: "Measurements",
            acknowledge: "acknowledge",
            download: "Download",
            cursortemperature: "Cursor temperature",
            cursortooltip: "Click on the image to know temperature at a desired position",
            regionsdata: "Regions data",
            region: "Region",
            pointsdata: "Points data",
            value: "Value",
            alertrules: "Alert rules",
            difference: "Difference",
            in: "in"
        },
    },


    intrusion: {
        search: "Search",
        filterby: "Filter by",
        intrusionactive: "Intrusion active",
        intrusionnotconsulted: "Intrusion not consulted",
        selectanintrusionfolder: "Select an intrusion folder",
        notconsulted: "not consulted",
        active: "active",
        january: "January",
        february: "February",
        march: "March",
        april: "April",
        may: "May",
        june: "June",
        july: "July",
        august: "August",
        september: "September",
        october: "October",
        november: "November",
        december: "December",
        before: "Before",
        intrusion: "intrusion",

        intrusionDetailsCard: {
            notavailable: "Not available",
            time: "Time",
            thisintrusionisactive: "This intrusion is active",
            environment: "Environment",
            temperature: "Temperature",
            humidity: "Humidity",
            configuration: "Configuration",
            triggerthreshold: "Trigger threshold",
            emissivity: "Emissivity",
            inintrusion: "In intrusion status",
            internal: "Internal",
            fpatemperature: "FPA temperature",
            measuredtemperatures: "Measured temperatures",
            measurements: "Measurements",
            masksexcluded: "Masks excluded",
            masksincluded: "Masks included",
            acknowledge: "acknowledge",
            download: "Download",
            cursortemperature: "Cursor temperature",
            cursortooltip: "Click on the image to know temperature at a desired position",
            regionsdata: "Regions data",
            region: "Region",
            pointsdata: "Points data",
            value: "Value",
            alertrules: "Alert rules",
            difference: "Difference",
            in: "in",
            basicinformations: "Basic Informations"
        },
    },

    screenshots: {
        selectascreenshot: "Select a screenshot",
        search: "Search",
        january: "January",
        february: "February",
        march: "March",
        april: "April",
        may: "May",
        june: "June",
        july: "July",
        august: "August",
        september: "September",
        october: "October",
        november: "November",
        december: "December",
        before: "Before",
        screenshots: "screenshots",

        screenshotDetailsCard: {
            masksexcluded: "Masks excluded",
            masksincluded: "Masks included",
            notavailable: "Not available",
            time: "Time",
            alertscreenshot: "Alert screenshot",
            manualscreenshot: "Manual screenshot",
            programmablescreenshot: "Programmed screenshot",
            environment: "Environment",
            temperature: "Temperature",
            humidity: "Humidity",
            configuration: "Configuration",
            triggerthreshold: "Trigger threshold",
            emissivity: "Emissivity",
            inalarm: "In alarm",
            internal: "Internal",
            fpatemperature: "FPA temperature",
            measuredtemperatures: "Measured temperatures",
            measurements: "Measurements",
            cursortooltip: "Click on the image to know temperature at a desired position",
            cursortemperature: "Cursor temperature",
            download: "Download",
            delete: "Delete",
            regionsdata: "Regions data",
            region: "Region",
            pointsdata: "Points data",
            value: "Value",
            alertrules: "Alert rules",
            difference: "Difference",
            in: "in"
        }
    },

    users: {
        role: "Role",
        search: "Search",
        invite: "Invite",
        username: "Username",
        email: "Email",
        phonenumber: "Phone number",
        country: "Country",
        phone: "Phone",
        invitationStatus: "Invitation status",
        notifications: "Notifications",
        actions: "Actions",
        cancel: "Cancel",
        validate: "validate",
        newuser: "Invite new user",
        newUserOK: "New user invited",
        edituser: "Edit user",
        deleteUserOK: "User has been correctly deleted.",
        editUserOK: "Your changes have been saved.",
        nameisrequired: "Name is required",
        emailmustbevalid: "Email must be valid",
        emailisrequired: "Email is required",
        emailalreadyinuse: "Email address already in use",
        roleRequired: "Role is required",
        areyousureyouwanttodeletethisuser: "Are you sure you want to delete this user",
        thisuserwillnotbeabletoreconnect: "This user will not be able to reconnect to the organization.",
        ok: "Ok",
        event: "Event",
        warning: "Warning : SMS notification generates additional costs.",
        sendmail:"Send email",
        sendSMS:"Send SMS",
        info:"The occurence of this event generates, in its minimal configuration, a notification by email.",
        notifutc:"E-mail notification of this event is not affected by UTC settings.",
        required: "Required field",
        nb1:"The sending of notifications by a UTC depends on the activation of the « Notifications » parameter of this UTC (tab « UTC »).",
        emailAlreadyExistOnThisOrganization: "This user (e-mail address) already exist on this organization",
        nb2:"The deactivation of this parameter suspends the sending of all the notifications of a UTC except the notification by email in case of alarm and intrusion."
    },

    account: {
        modify: "Modify",
        password: "Password",
        reset: "Reset",
        save: "Save",
        username: "Username",
        email: "Email",
        phonenumber: "Phone Number",
        usernameisrequired: "Username is required",
        changesOK: "Your changes have been saved.",
        emailChangesOK: "Your e-mail has been changed",
        phoneChangesOK: "Your phone number has been changed",
        warning: "Warning : SMS notification generates additional costs.",
        event: "Event",
        sendmail:"Send email",
        sendSMS:"Send SMS",
        info:"The occurence of this event generates, in its minimal configuration, a notification by email.",
        notifutc:"E-mail notification of this event is not affected by UTC settings.",
        required: "Required field",
        nb1:"The sending of notifications by a UTC depends on the activation of the « Notifications » parameter of this UTC (tab « UTC »).",
        nb2:"The deactivation of this parameter suspends the sending of all the notifications of a UTC except the notification by email in case of alarm and intrusion.",
        organization: "Organization : ",
        role: "Role : ",
        oragnizationCannotBeUsedRentalPeriod1: "This organization : ",
        oragnizationCannotBeUsedRentalPeriod2: ", cannot be used as it has reached the end of the rental period. Please contact UTC-SYSTEM for assistance.",
        phonenumberisrequiredtoreceivesms: "You haven't entered a phone number, but SMS notifications have been set up for you in at least one organization.",
        
        changeMail: {
            mailchange: "E-mail changing",
            newMail: "New e-mail",
            verificationCode: "Verification code",
            save: "Save",
            cancel: "Cancel",
            emailisrequired: "Email is required",
            emailmustbevalid: "Email must be valid",
            emailalreadyinuse: "Email address already in use",
            wrongverificationcode: "Wrong verification code",
        },

        changePassword: {
            passwordchange: "Password changing",
            currentpassword: "Current password",
            newpassword: "New password",
            passwordconfirmation: "Confirm Password",
            save: "Save",
            cancel: "Cancel",
            actualpasswordisrequired: "Current password is required",
            passwordisrequired: "New password is required",
            yourpasswordshouldcontainatleastoneuppercase: "Your password should contain at least one upper case",
            yourpasswordshouldcontainatleastonedigit: "your password should contain at least one digit",
            yourpasswordshouldcontainatleastonelowercase: "Your password should contain at least one lower case",
            yourpasswordmustcontainatleastonespecialcharacter: "Your password must contain at least one special character",
            yourpasswordshouldcontainatleast8characters: "Your password should contain at least 8 characters",
            confirmationisrequired: "Confirmation is required",
            youenteredabadcurrentpassword: "You entered a bad current password",
            yournewpassworddoesntmatchwithpasswordconfirmation: "Your new password doesn't match with password confirmation",
            yournewpasswordisthesamethanthecurrentone: "Your new password with old password are same",
            passwordChangedOK: "Your new password has been set. You are going to be disconnected.",
        },

        changePhoneNumber: {
            phonechange: "Phone number changing",
            save: "Save",
            cancel: "Cancel",
            country: "Country",
            phonenumber: "Phone Number",
        },

        newPassword: {
            newpassword: "New password",
            passwordconfirmation: "Confirm Password",
            validate: "Validate",
            cancel: "Cancel",
            passwordisrequired: "New password is required",
            yourpasswordshouldcontainatleastoneuppercase: "Your password should contain at least one upper case",
            yourpasswordshouldcontainatleastonedigit: "your password should contain at least one digit",
            yourpasswordshouldcontainatleastonelowercase: "Your password should contain at least one lower case",
            yourpasswordmustcontainatleastonespecialcharacter: "Your password must contain at least one special character",
            yourpasswordshouldcontainatleast8characters: "Your password should contain at least 8 characters",
            confirmationisrequired: "Confirmation is required",
            yournewpassworddoesntmatchwithpasswordconfirmation: "Your new password doesn't match with password confirmation",
        },

        requestNewPassword: {
            email: "Email",
            validate: "Validate",
            cancel: "Cancel",
        },
    },

    invite: {
        required: "Required field",
        username: "Username",
        email: "Email",
        phonenumbermustbevalid: "Phone number must be valid",
        newpassword: "New password",
        passwordconfirmation: "Confirm Password",
        validate: "validate",
        cancel: "Cancel",
        nameisrequired: "Name is required",
        passwordisrequired: "New password is required",
        yourpasswordshouldcontainatleastoneuppercase: "Your password should contain at least one upper case",
        yourpasswordshouldcontainatleastonedigit: "your password should contain at least one digit",
        yourpasswordshouldcontainatleastonelowercase: "Your password should contain at least one lower case",
        yourpasswordmustcontainatleastonespecialcharacter: "Your password must contain at least one special character",
        yourpasswordshouldcontainatleast8characters: "Your password should contain at least 8 characters",
        confirmationisrequired: "Confirmation is required",
        onSupervision: "You are now registered on UTC-SUPERVISION, you will be redirected to the login page.",
        onOrgaSupervision: "You're now part of a new organization.",
    },

    organization: {
        validate: "Validate",
        cancel: "Cancel",
        save: "Save", 
        reset: "Reset",
        changesOK: "Your changes have been saved.",
        createOrga: "Create Orga",
        deleteOrga: "Delete Orga",
        changeOrgaNameFrom: "Change Organization name from : ",

        newOrga: {
            addOrga: "Create new organization",
            name: "Organization name",
            orderNb: "Order Number",
            validate: "validate",
            cancel: "Cancel",
            newOrgaOK: "New organization created.",
            newOrgaNOK: "Impossible to create this organization.",
            newOrgaDuplicate: "This organization already exist for this order number",
        },

        delOrga: {
            delOrga: "Delete organization",
            name: "Organization name",
            orderNb: "Order Number",
            validate: "validate",
            cancel: "Cancel",
            delOrgaOK: "Organization deleted.",
            delOrgaNOK: "Impossible to delete this organization."
        }
    },
    
    support: {
        contactus: "Contact us",
        reportaproblem: "Report a problem",
        category: "Category",
        utcsensor: "UTC sensor",
        webpage: "Web page",
        othersubject: "Other subject",
        subject: "Subject",
        yourmessage: "Your message",
        fileinput: "File input",
        report: "Report",
        categoryisrequired: "Category required",
        subjectisrequired: "Subject required",
        messageisrequired: "Message required",
        supportmailOK: "Your message has been sent. You will receive a reply as soon as possible.",
        supportmailNOK: "Your message could not be sent. Please try again later",
    },
}